const AIDesk = {
  "结束会话": "Kết thúc cuộc trò chuyện với người",
  "转人工服务": "Chuyển sang dịch vụ của người",
  "跳转": "Chuyển hướng",
  "立即填写": "Điền ngay",
  "已提交": "Đã gửi",
  "提交": "Gửi",
  "查看内容": "Xem nội dung",
  "请填写必填项": "Vui lòng điền vào các mục bắt buộc",
  "请输入内容":"Vui lòng nhập nội dung",
  "如果满意请给好评哦～":"Nếu bạn hài lòng, hãy cho chúng tôi một đánh giá tốt nhé~",
  "请对本次服务进行评价": "Vui lòng đánh giá dịch vụ này",
  "提交评价": "Gửi đánh giá",
  "服务评价": " Đánh giá dịch vụ",
  "并发限制": "Hiện có quá nhiều người đang truy cập. Vui lòng thử lại sau",
  "分支选项异常": "Nội dung bất thường, vui lòng kiểm tra cấu hình luồng tác vụ",
  "满意": "Hài lòng",
  "不满意": "Không hài lòng",
  "感谢您的反馈，我们会持续优化改进": "Cảm ơn phản hồi của bạn, chúng tôi sẽ tiếp tục cải thiện",
  "您遇到了哪方面的问题": "Bạn gặp vấn đề gì",
  "其他反馈内容": "Phản hồi khác",
  "取消": "Hủy",
  "答非所问": "Câu trả lời không liên quan",
  "未匹配相关内容": "Không có nội dung phù hợp",
  "信息错误": "Thông tin sai",
  "上下文理解错误": "Hiểu sai ngữ cảnh",
  "格式不规范": "Định dạng không chuẩn",
  "内容不完整": "Nội dung không đầy đủ",
  "file 大小超过 100MB，无法发送": "Kích thước tệp vượt quá 100MB, không thể gửi",
  "image 大小超过 20MB，无法发送": "Kích thước hình ảnh vượt quá 20MB, không thể gửi",
  "video 大小超过 100MB，无法发送": "Kích thước video vượt quá 100MB, không thể gửi",
  "提交成功": "Gửi thành công",
  "userID 只能包含可打印 ASCII 字符": "UserID chỉ được chứa ký tự ASCII có thể in được",
  "userID 不能包含'administrator'": "UserID không được chứa 'administrator'",
  "userID 长度不能超过45字节": "Độ dài UserID không được vượt quá 45 byte",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "Chúng tôi rất cảm kích phản hồi của bạn. Vui lòng chia sẻ bất kỳ đề xuất nào để giúp chúng tôi cải thiện.",
  "排队等待中": "Đang chờ trong hàng",
  "排队等待话术": "Xin lỗi, tất cả nhân viên chăm sóc khách hàng hiện đang bận. Vui lòng chờ đợi, chúng tôi sẽ phục vụ bạn sớm nhất có thể. Cảm ơn bạn đã thông cảm.",
  "当前前方排队人数": "Số người đang chờ trước bạn trong hàng",
  "结束排队": "Rời khỏi hàng",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "Đánh giá sau khi gửi hơn 3 phút sẽ không thể chỉnh sửa.",
  "不能发送空白消息": "Không thể gửi tin nhắn trống",
  "确认转人工": "Xác nhận chuyển tiếp sang nhân viên",
}
export default AIDesk;
